import React from 'react'

import './cards.css'
import { getLink, getLinkFromRef, getMargins } from '../../utility'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import ButtonLinkCtaList from '../link/buttonLinkCtaList.jsx'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import CardImage from './cardImage.jsx'

const BGCOLOR = [
  {
    value: '',
    cssClass: '',
  },
  {
    value: 'Light Gray',
    cssClass: 'u-bgColorLight',
  },
  {
    value: 'Brand',
    cssClass: 'u-bgColorBrand',
  },
  {
    value: 'Brand Dark',
    cssClass: 'u-bgColorBrandDark',
  },
  {
    value: 'White',
    cssClass: 'u-bgColorWhite',
  },
]

const ALIGNMENT = {
  Default: 'Default',
  LEFT: 'Left',
  CENTER: 'Center',
}

const CardsWrapper = ({ page, component }) => {
  const _parameters = component?.getParameters()
  const parameter = {
    columns: _parameters.columns || 0,
    backgroundColor: _parameters.backgroundColor || '',
    marginTop: _parameters.marginTop || 'No Spacing',
    marginBottom: _parameters.marginBottom || 'No Spacing',
    alignment: _parameters.alignment || ALIGNMENT.LEFT,
  }

  let items = []
  const _models = component.getModels()
  if (_models?.pagination) {
    const { pagination: _paginationRef } = _models
    const pagination = _paginationRef && page.getContent(_paginationRef)
    if (pagination) {
      const itemRefs = pagination?.getItems()
      const documents = itemRefs
        ?.map((itemRef) => itemRef && page.getContent(itemRef))
        ?.filter((doc) => !!doc)
      items = documents?.map((doc) => {
        const data = doc.getData()
        const imageSrc = data?.imageDetails?.image
          ? page?.getContent(data?.imageDetails?.image)
          : null
        return {
          id: data?.id,
          title: data?.title || '',
          subTitle: data?.subTitle || '',
          body: data?.body?.html?.value || '',
          linkList:
            data?.links?.length > 0
              ? data?.links
                  ?.filter((l) => l.link && l.link.length > 0)
                  ?.map((l) => getLink(getLinkFromRef(l, page), null))
              : [],
          image: {
            ...data?.imageDetails,
            image: imageSrc,
            alignment:
              data?.imageDetails?.alignment &&
              data?.imageDetails?.alignment !== ALIGNMENT.Default
                ? data?.imageDetails?.alignment
                : parameter.alignment,
            resolution:
              data?.imageDetails?.resolution &&
              data?.imageDetails?.resolution !== 'default'
                ? data?.imageDetails?.resolution
                : 'medium',
          },
          document: doc,
        }
      })
    }
  }

  const textAlignment =
    parameter.alignment === ALIGNMENT.LEFT
      ? 'u-textLeft'
      : parameter.alignment === ALIGNMENT.CENTER
        ? 'u-textCenter'
        : ''
  const buttonAlignment =
    parameter.alignment === ALIGNMENT.LEFT
      ? 'u-flexJustifyStart'
      : parameter.alignment === ALIGNMENT.CENTER
        ? 'u-flexJustifyCenter'
        : ''
  const headingTextColor =
    parameter.backgroundColor === 'Brand Dark'
      ? 'u-textColorWhite'
      : 'u-textColorBrandDark'
  const bodyTextColor =
    parameter.backgroundColor === 'Brand Dark'
      ? 'u-textColorWhite'
      : 'u-textColorSlateDark'
  const border =
    parameter.backgroundColor === 'White' ? 'card-border-light' : ''

  const cardContentPadding =
    parameter.backgroundColor !== '' ? 'u-paddingTop5gu u-paddingHoriz5gu' : ''
  const cardFooterPadding =
    parameter.backgroundColor !== ''
      ? 'u-paddingBottom5gu u-paddingHoriz5gu'
      : ''

  const background =
    BGCOLOR.find((color) => color.value === parameter.backgroundColor)
      ?.cssClass || ''
  const columns = parameter.columns || (items.length > 4 ? 4 : items.length)
  const imageMarginBottom =
    parameter.backgroundColor === '' ? 'u-marginBottom5gu' : ''

  return (
    <div
      className={`Cards u-sizeConstrained ${getMargins(parameter.marginTop, parameter.marginBottom)}`}
    >
      <div className="Grid Grid--withGutter">
        {items.map((item) => (
          <CardDisplay
            key={item.id}
            title={item.title}
            subTitle={item.subTitle}
            body={item.body}
            linkList={item.linkList}
            image={item.image}
            document={item.document}
            columns={columns}
            textAlignment={textAlignment}
            buttonAlignment={buttonAlignment}
            headingTextColor={headingTextColor}
            bodyTextColor={bodyTextColor}
            border={border}
            cardContentPadding={cardContentPadding}
            cardFooterPadding={cardFooterPadding}
            background={background}
            imageMarginBottom={imageMarginBottom}
          />
        ))}
      </div>
    </div>
  )
}

export default CardsWrapper

const CardDisplay = ({
  title,
  subTitle,
  body,
  linkList,
  columns = 0,
  image = {},
  document = null,
  textAlignment = '',
  buttonAlignment = '',
  headingTextColor = '',
  bodyTextColor = '',
  border = '',
  cardContentPadding = '',
  cardFooterPadding = '',
  background = '',
  imageMarginBottom = '',
}) => {
  return (
    <div
      className={`u-flex u-flexCol u-sm-sizeFull u-md-size1of${columns} u-lg-size1of${columns} u-posRelative`}
    >
      {document && <BrManageContentButton content={document} />}
      <div className={`card u-flex u-flexCol ${background} ${border}`}>
        <div className="card-content">
          {image?.image && (
            <CardImage
              wrapperClassNames={imageMarginBottom}
              image={image?.image}
              {...image}
            />
          )}
          <div className={`${cardContentPadding}`}>
            <h3 className={`u-textBold ${textAlignment} ${headingTextColor}`}>
              {title}
            </h3>
            <p className={`u-textSizeMsrm1 ${bodyTextColor}`}>{subTitle}</p>
            <HippostdHtml
              value={body}
              classNames={`${textAlignment} ${bodyTextColor}`}
            />
          </div>
        </div>
        <div className={`card-footer ${cardFooterPadding}`}>
          {linkList && linkList.length > 0 && (
            <ButtonLinkCtaList
              ctaWrapperClassNames={`u-marginTop2gu ${buttonAlignment}`}
              linkList={linkList}
            />
          )}
        </div>
      </div>
    </div>
  )
}
